<template>

    <v-app-bar app dense fixed shrink-on-scroll fade-img-on-scroll scroll-threshold="300" :elevation="0">
      <router-link to="/" style="text-decoration: none; color: inherit;">
        <v-toolbar-title class="pa-0">
          <v-img src="https://medicover.mx/img/logomedicoverweb.svg" contain max-width="150" max-height="50"
            class="mx-0" alt="Logo Medicover" lazy-src="https://medicover.mx/img/logomedicoverweb.svg" />
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text to="/" class="hidden-sm-and-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-house"
            viewBox="0 0 16 16">
            <path
              d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
          </svg>
        </v-btn>
        <!-- <v-btn text to="/cotizacion" class="hidden-sm-and-down">Cotizador</v-btn> -->
        <v-btn text @click="$goToSection('seccionPlanes', '/')" class="hidden-sm-and-down">Planes</v-btn>
        <v-btn text to="/especialidades-medicas" class="hidden-sm-and-down">Especialidades</v-btn>
        <v-btn text to="/red-hospitalaria" class="hidden-sm-and-down">Red Hospitalaria</v-btn>
        <v-menu open-on-hover transition="slide-x-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" class="hidden-md-and-up">MENU</v-btn>
          </template>
          <v-list dense>
            <v-list-item router to="/">
              <v-list-item-action>
                <v-list-item-title>INICIO</v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-list-item router @click="$goToSection('seccionPlanes', '/')">
              <v-list-item-action>
                <v-list-item-title>PLANES</v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-for="(item, index) in menu" :key="index" router :to="item.link">
              <v-list-item-action>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- open-on-hover -->
        <v-menu transition="slide-x-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">INICIAR SESION</v-btn>
          </template>
          <v-card class="mx-auto" tile>
            <v-list dense>
              <v-subheader>Bienvenido</v-subheader>
              <v-list-item-group v-model="theme" color="primary">
                <v-list-item v-for="(item, i) in themes" :key="i" router   @click="cambiarPerfil(item)">
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
        <Carrito></Carrito>
      </v-toolbar-items>
    </v-app-bar>

</template>
<script>
// import { mapGetters } from 'vuex'
import Carrito from '@/components/Layout/CarritoComponent.vue'
const loginPaths = {
  colaborador: '/login-colaborador',
  cliente: '/login-cliente',
  hospital: '/login-hospital',
  medico: '/login-medico',
  agente: '/login-agente'
};
export default {
  name: 'AppHeader',
  methods:{
    
    cambiarPerfil(item) {
      // quitar para hospitales
      console.log(item.link)
      if(item.link === "https://adm.medicover.mx/urgencias_sesion.php" || item.link === "https://adm.medicover.mx/admin_sesion.php"){
          window.location.href = item.link;
      }else{
    localStorage.removeItem('id')
    localStorage.removeItem('token')
    localStorage.removeItem('nombres')
    localStorage.removeItem('aPaterno')
    localStorage.removeItem('aMaterno')
    localStorage.removeItem('NombresApaterno')
    localStorage.removeItem('email')
    localStorage.removeItem('codAge')
    localStorage.removeItem('menu')
    localStorage.removeItem('idTarjetaTxt')
    localStorage.removeItem('idTarjeta')
        localStorage.setItem('tipoUsuario', item.perfil);


        
        const destino = loginPaths[item.perfil] || '/login-cliente';

        // Compara fullPath para evitar navegación redundante
        if (this.$route.fullPath === this.$router.resolve(destino).href) {
          return; // ya estás en la misma ruta, no navegamos
        }

        this.$router.push(destino).catch(err => {
          if (!err.message.includes('Redirected when going') && err.name !== 'NavigationDuplicated') throw err;
        });
      }
    }
  },
  components: {
    Carrito
  },
  computed: {
    logoProperties() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return {
            width: '100px'
          }
        case 'sm':
          return {
            width: '100px'
          }
        case 'md':
          return {
            width: '112px'
          }
        case 'lg':
          return {
            width: '112px'
          }
        case 'xl':
          return {
            width: '100px;'
          }
        default:
          return {
            width: '100px'
          }
      }
    },
    PopAgendatel() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return {
            width: '50%'
          }
        case 'sm':
          return {
            width: '60%'
          }
        case 'lg':
          return {
            width: '40%'
          }
        case 'xl':
          return {
            width: '40%'
          }
        default:
          return {
            width: '50%'
          }
      }
    }
  },
  data: () => ({
    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Web Hola, ')}`,
    heading: [
      { id: 1, txt: 'caption' },
      { id: 2, txt: 'caption' },
      { id: 3, txt: 'caption' }
    ],
    modaltel: false,
    modaltel1: false,
    // name: localStorage.name,
    drawer: false,
    group: null,
    activate: true,
    theme: 0,
    themes: [
            {
        text: 'USUARIO',
        icon: 'mdi-account',
        //link: `${process.env.VUE_APP_BASE_ADMY}medicover_sesion.html`
        link: `/user/micuenta`,
        perfil:'usuario'
      },
      {
        text: 'HOSPITAL',
        icon: 'mdi-hospital',
        //link: `${process.env.VUE_APP_BASE_ADMY}urgencias_sesion.php`,
        link: `hospital/urgencias-medicas`,
        perfil: 'hospital'
        //link: ` /urgencias`
      },
      {
        text: 'MEDICO',
        icon: 'mdi-stethoscope',
        link: `${process.env.VUE_APP_BASE_ADMY}medicos_sesion.php`
      },
      {
        text: 'AGENTE',
        icon: 'mdi-account-tie',
        link: `/agente/cobranza`,
        perfil: 'agente'
        //link: `${process.env.VUE_APP_BASE_ADMY}agentes_sesion.php`
      },
      {
        text: 'COLABORADOR',
        icon: 'mdi-account-group',
        link: `/colaborador`,
        perfil: 'colaborador'
        //link: `${process.env.VUE_APP_BASE_ADMY}agentes_sesion.php`
      },
    // {
    //     text: 'NEW',
    //     icon: 'mdi-hospital',
    //   //  link: `${process.env.VUE_APP_BASE_ADMY}urgencias_sesion.php`,
    //     link: `hospital/urgencias-medicas`,
    //     perfil: 'hospital'
    //   },
      {
        text: 'ADMINISTRADOR',
       // icon: 'mdi-shield-account',
        link: `${process.env.VUE_APP_BASE_ADMY}admin_sesion.php`
      },
    ],
    menu: [
      // {
      //   text: 'COTIZADOR',
      //   icon: 'mdi-clock',
      //   link: '/cotizacion'
      // },
      {
        text: 'MEDICOS Y ESPECIALIDADES',
        icon: 'mdi-account',
        link: '/especialidades-medicas'
      },
      {
        text: 'RED HOSPITALARIA',
        icon: 'mdi-account',
        link: '/red-hospitalaria'
      },
      /* {
       text: 'PLAN ACCIONA POR LA SALUD',
       icon: 'mdi-account',
       link: '/',
     },
     */
    ]
  })
}
</script>